export interface OperatorRoleToggleState {
  originalHasOperatorRole: boolean;
  operatorOverride: boolean | null;
}

export function parseOperatorOverrideStorageValue(
  operatorOverride: string | null,
) {
  if (operatorOverride === 'false') {
    return false;
  }

  return null;
}

export function canUseOperatorDebug(originalHasOperatorRole: boolean) {
  return originalHasOperatorRole;
}

export function getEffectiveOperatorRole({
  originalHasOperatorRole,
  operatorOverride,
}: OperatorRoleToggleState) {
  if (!canUseOperatorDebug(originalHasOperatorRole)) {
    return false;
  }

  return operatorOverride !== false;
}

export function getNextOperatorOverride({
  originalHasOperatorRole,
  operatorOverride,
}: OperatorRoleToggleState) {
  if (!canUseOperatorDebug(originalHasOperatorRole)) {
    return null;
  }

  if (
    getEffectiveOperatorRole({
      originalHasOperatorRole,
      operatorOverride,
    })
  ) {
    return false;
  }

  return null;
}

export function serializeOperatorOverride(next: boolean | null) {
  if (next === false) {
    return 'false';
  }

  return null;
}
